export default ({ app }) => {
  if (process.client) {
    // Flag to prevent duplicate tracking
    let initialTracked = false;

    // Setup Matomo queue
    window._paq = window._paq || [];

    window._paq.push([
      "setDocumentTitle",
      document.domain + "/" + document.title,
    ]);
    window._paq.push(["setCookieDomain", "*.abalon.cloud"]);
    window._paq.push(["setDomains", ["*.abalon.cloud"]]);
    window._paq.push(["setDoNotTrack", true]);
    window._paq.push(["enableLinkTracking"]);

    // Configuration
    var u = "//matomo.abalon.cloud/";
    window._paq.push(["setTrackerUrl", u + "matomo.php"]);
    window._paq.push(["setSiteId", "1"]);

    // Track function
    const track = () => {
      if (!initialTracked && window._paq) {
        window._paq.push(["setCustomUrl", window.location.href]);
        window._paq.push(["setDocumentTitle", document.title]);
        window._paq.push(["trackPageView"]);
        initialTracked = true;
      }
    };

    // Load script and track immediately after
    var script = document.createElement("script");
    script.async = true;
    script.src = u + "matomo.js";
    script.onload = track; // Track only once when loaded
    document.head.appendChild(script);

    // Track navigation (but NOT initial load)
    let firstRoute = true;
    app.router.afterEach((to, from) => {
      if (firstRoute) {
        firstRoute = false;
        return; // Skip the initial route
      }

      setTimeout(() => {
        if (window._paq) {
          window._paq.push(["setCustomUrl", window.location.href]);
          window._paq.push(["setDocumentTitle", document.title]);
          window._paq.push(["trackPageView"]);
        }
      }, 100);
    });
  }
};
